import React from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';

// GeoJSON simplificado do Brasil
const BRAZIL_TOPO_JSON = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const BrazilMap = ({ stateData = [], cityData = [] }) => {
  // Criar mapa de códigos de estado para valores
  const stateMap = {};
  stateData.forEach(state => {
    stateMap[state.code] = state.count;
  });

  // Encontrar valor máximo para escala de cores
  const maxCount = Math.max(...stateData.map(s => s.count), 1);

  const getStateColor = (stateCode) => {
    const count = stateMap[stateCode] || 0;
    if (count === 0) return '#f0f0f0';

    const intensity = count / maxCount;
    const hue = 210; // Azul
    const saturation = 70 + (intensity * 30);
    const lightness = 85 - (intensity * 50);

    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{
          scale: 600,
          center: [-52, -14]
        }}
        style={{ width: '100%', height: '100%' }}
      >
        <Geographies geography={BRAZIL_TOPO_JSON}>
          {({ geographies }) =>
            geographies.map(geo => {
              const stateCode = geo.properties.sigla || geo.properties.UF || geo.properties.name?.substring(0, 2)?.toUpperCase();
              const count = stateMap[stateCode] || 0;

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={getStateColor(stateCode)}
                  stroke="#ffffff"
                  strokeWidth={0.5}
                  style={{
                    default: { outline: 'none' },
                    hover: {
                      fill: '#007bff',
                      outline: 'none',
                      cursor: 'pointer'
                    },
                    pressed: { outline: 'none' }
                  }}
                >
                  <title>{`${geo.properties.name || stateCode}: ${count} acessos`}</title>
                </Geography>
              );
            })
          }
        </Geographies>

        {/* Marcadores para as principais cidades */}
        {cityData.slice(0, 10).map((city, index) => (
          <Marker key={index} coordinates={[city.longitude, city.latitude]}>
            <circle
              r={Math.min(4 + (city.count / 5), 12)}
              fill="#dc3545"
              stroke="#fff"
              strokeWidth={1}
              opacity={0.8}
              style={{ cursor: 'pointer' }}
            >
              <title>{`${city.city}, ${city.stateCode}: ${city.count} acessos`}</title>
            </circle>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
};

export default BrazilMap;
